export const comments_5698795 = {"data":{"data":[],"links":{}}}